import { render, staticRenderFns } from "./AjaxLoader.vue?vue&type=template&id=5f1e5cf3&scoped=true&lang=pug&"
import script from "./AjaxLoader.vue?vue&type=script&lang=ts&"
export * from "./AjaxLoader.vue?vue&type=script&lang=ts&"
import style0 from "./AjaxLoader.vue?vue&type=style&index=0&id=5f1e5cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e5cf3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
